import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { ConvertErrorArrayToString } from "../../Services/Common";
import { setToastData } from "../../Store/reducers/Toast";

const MakePayments = () => {
    const dispatch = useDispatch();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [dressAmountTypeList, setDressAmountTypeList] = useState([]);
    useEffect(() => {
        dispatch(setMainLoading(true));
        dispatch(setPageTitle('Make Payments'));
        PostAxios(`payments/get-tts-types`, {}, accessToken)
            .then(({ data }) => {
                if (data.data) {
                    setDressAmountTypeList(data.data);
                }
                dispatch(setMainLoading(false));
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err);
            })
    }, [accessToken, dispatch]);
    const calculateAccessoriesPrice = (al) => {
        if (al.length > 0) {
            let totalPrice = 0;
            al.map((item, index) => {
                totalPrice += dressAmountTypeList['accessories'][item].price;
            })
            return totalPrice;
        }
        return 0;
    }
    const MyCheckbox = ({ field, form, label, ...rest }) => {
        const { name, value: formikValue } = field;
        const { setFieldValue } = form;
        const handleChange = event => {
            const values = formikValue || [];
            const index = values.indexOf(rest.value);
            if (index === -1) {
                values.push(rest.value);
            } else {
                values.splice(index, 1);
            }
            setFieldValue(name, values);
        };
        return (
            <label className="container-checkbox">
                <input
                    type="checkbox"
                    onChange={handleChange}
                    checked={formikValue.indexOf(rest.value) !== -1}
                    {...rest}
                />
                <span className="checkmark"></span>
                {label}
            </label>
        );
    };
    return (
        <div className="main-form-sec">
            <Formik
                initialValues={{
                    transaction_type: '',
                    accessories_list: []
                }}
                //enableReinitialize={true}
                validate={values => {
                    const errors = {};
                    if (!values.transaction_type) { errors.transaction_type = "Please choose transaction_type"; }
                    if (values.transaction_type === "accessories" && values.accessories_list.length < 1) { errors.accessories_list = "Please choose atleast 1 accessories"; }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    dispatch(setMainLoading(true));
                    PostAxios(`payments/initiate`,{
                        transaction_type: values.transaction_type,
                        accessories_list: values.accessories_list
                    },accessToken)
                    .then(({data})=>{
                        if(data.status === '1'){
                            dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }));
                            resetForm();
                            const form = document.createElement('form');
                            form.method = 'post';
                            form.action = data.payment_url;

                            const encRequestInput = document.createElement('input');
                            encRequestInput.type = 'hidden';
                            encRequestInput.name = 'encRequest';
                            encRequestInput.value = data.encrypted_data;

                            const accessCodeInput = document.createElement('input');
                            accessCodeInput.type = 'hidden';
                            accessCodeInput.name = 'access_code';
                            accessCodeInput.value = data.access_code;

                            form.appendChild(encRequestInput);
                            form.appendChild(accessCodeInput);

                            document.body.appendChild(form);
                            form.submit();
                        }
                        else{
                            dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                        }
                        dispatch(setMainLoading(false));
                        setSubmitting(false);
                    })
                    .catch((err)=>{
                        responseCatchFunc(dispatch,err)
                        setSubmitting(false);
                    })
                    
                }}
            >
                {({ errors, touched, isSubmitting, handleChange, setFieldValue, values }) => (
                    <Form>
                        <div className="form-sec">
                            <div className={`form-field-group w-50 ${(errors.transaction_type && touched.transaction_type) ? 'error-input' : ''}`}>
                                <div className="w-50">
                                    <label htmlFor="transaction_type">Uniform Type</label>
                                </div>
                                <div className="w-50">
                                    <label className="select-input-outer select-100">
                                        <Field name="transaction_type" as="select" className="select-input" >
                                            <option value="">Choose Uniform Type</option>
                                            {
                                                Object.values(dressAmountTypeList).length > 0 && <>
                                                    <option value="uniform_with_accessories" >{dressAmountTypeList['uniform_with_accessories'].name}</option>
                                                    <option value="jacket" >{dressAmountTypeList['jacket'].name}</option>
                                                    <option value="accessories" >Accessories</option>
                                                </>
                                            }
                                        </Field>
                                    </label>
                                    <ErrorMessage component="span" name="transaction_type" className="error-label" />
                                </div>
                            </div>
                            {
                                values.transaction_type !== "" &&
                                <div className={`form-field-group w-50`}>
                                    <div className="w-100">
                                        <label htmlFor="transaction_type" style={{fontSize:'1.2rem'}}>Price : &nbsp;
                                            <i className="fa-solid fa-indian-rupee-sign"></i> {values.transaction_type !== "accessories" ? dressAmountTypeList[values.transaction_type].price : calculateAccessoriesPrice(values.accessories_list)}/-
                                        </label>
                                    </div>
                                </div>
                            }
                            {
                                values.transaction_type === "accessories" &&
                                <div className={`form-field-group w-100 ${(errors.accessories_list && touched.accessories_list) ? 'error-input' : ''}`}>
                                    <div className="w-30">
                                        <label htmlFor="accessories_list">Accessories</label>
                                    </div>
                                    <div className="w-70">
                                        <div className="checkbox-outer accss_list_chk_bxs" role="group" aria-labelledby="checkbox-group">
                                            {
                                                Object.values(dressAmountTypeList['accessories']).map((item, index) => {
                                                    return <Field key={`accessories-key-${item.key}`} component={MyCheckbox} name="accessories_list" value={item.key} label={item.name} />
                                                })
                                            }
                                        </div>
                                        <ErrorMessage component="span" name="accessories_list" className="error-label" />
                                    </div>
                                </div>
                            }
                            <div className="btm-right-btn justify-content-center my-3">
                                <button className="btn-blue btn" type="submit" disabled={isSubmitting}>PURCHASE</button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}
export default MakePayments;